import { render, staticRenderFns } from "./explanation.vue?vue&type=template&id=d94aab72&scoped=true&"
import script from "./explanation.vue?vue&type=script&lang=js&"
export * from "./explanation.vue?vue&type=script&lang=js&"
import style0 from "./explanation.vue?vue&type=style&index=0&id=d94aab72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94aab72",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex})
